"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var _peractoUi = require("@peracto/peracto-ui");

var _config = _interopRequireDefault(require("./config"));

var _excluded = ["name", "label", "help", "className", "showWhen"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var getCharacterCount = function getCharacterCount(html) {
  var doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent.length || 0;
};

var RichText = function RichText(_ref) {
  var name = _ref.name,
      label = _ref.label,
      help = _ref.help,
      className = _ref.className,
      showWhen = _ref.showWhen,
      props = _objectWithoutProperties(_ref, _excluded);

  var editorRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      editorLoaded = _useState2[0],
      setEditorLoaded = _useState2[1];

  var _ref2 = editorRef.current || {},
      CKEditor = _ref2.CKEditor,
      ClassicEditor = _ref2.ClassicEditor;

  (0, _react.useEffect)(function () {
    var _require = require('@peracto/ckeditor'),
        ClassicEditor = _require.ClassicEditor;

    var _require2 = require('@ckeditor/ckeditor5-react'),
        CKEditorReact = _require2.CKEditor;

    editorRef.current = {
      CKEditor: CKEditorReact,
      ClassicEditor: ClassicEditor
    };
    setEditorLoaded(true);
  }, []);
  return editorLoaded && /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name
  }, function (_ref3) {
    var field = _ref3.field,
        form = _ref3.form;
    var error = (0, _formik.getIn)(form.errors, name);

    if (error) {
      var errorFieldName = label ? label : 'This';
      error = error.replace(field.name, errorFieldName);
    }

    if (showWhen) {
      var showField = form.values.hasOwnProperty(showWhen) ? form.values[showWhen] : false;

      if (!showField) {
        return null;
      }
    }

    props.className = (0, _classnames["default"])('form-control', className);

    if (help) {
      props['aria-describedby'] = "".concat(name, "Help");
    }

    (0, _react.useEffect)(function () {
      var domEditableElement = document.querySelector('.ck-editor__editable');
      var editorInstance = domEditableElement === null || domEditableElement === void 0 ? void 0 : domEditableElement.ckeditorInstance;

      if (editorInstance) {
        editorInstance.editing.view.change(function (writer) {
          var viewEditableRoot = editorInstance.editing.view.domConverter.mapDomToView(domEditableElement);
          writer.setAttribute('data-testid', "richtext-".concat(name), viewEditableRoot);
        });
      }
    }, []);
    (0, _react.useEffect)(function () {
      var temp = document.getElementsByClassName('ck-editor__main');

      for (var index = 0; index < temp.length; index++) {
        var t1 = document.getElementsByClassName('ck-editor__main')[index];
        var t2 = document.createAttribute('data-testid');
        t2.value = "richtext-attribute-".concat(index);
        t1.setAttributeNode(t2);
      }
    });
    return /*#__PURE__*/_react["default"].createElement(_peractoUi.FormGroup, {
      name: name,
      label: label,
      help: help,
      charactercount: getCharacterCount(field.value || ''),
      error: error
    }, /*#__PURE__*/_react["default"].createElement(CKEditor, {
      editor: ClassicEditor,
      config: _objectSpread({
        placeholder: props.placeholder ? props.placeholder : 'Enter your text here...'
      }, _config["default"]),
      data: field.value || '',
      onChange: function onChange(event, editor) {
        form.setFieldValue(name, editor.getData());
      },
      disabled: form.isSubmitting || props.disabled
    }));
  });
};

RichText.displayName = 'RichText';
RichText.propTypes = {
  type: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  help: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  placeholder: _propTypes["default"].string,
  className: _propTypes["default"].string
};
RichText.defaultProps = {
  type: 'text'
};
var _default = RichText;
exports["default"] = _default;